<template>
    <div class="card">
      <div class="card-header" data-test="publicationCard-header">
        <div v-if="getMediaType(image) === 'unknown'" class="bg-app-photo">
            <img :src="require('@/assets/APP_PHOTO.png')" alt="Appareil photo image"/>
        </div>
        <div v-if="getMediaType(image) === 'Video found'">
         <video autoplay muted loop class="card-video">
           <source :src="image" type="video/mp4">
         </video>
        </div>
        <span v-if="getMediaType(image) === 'Image found'">
          <img v-if="!isUserDemo" :src="image" alt="Card Image" />
          <img v-else :src="getImageUrl(image)" alt="Card Image"/>
        </span>
      </div>
      <div class="card-body" data-test="publicationCard-body">
        <!-- Encart gauche -->
        <div class="card-left" data-test="publicationCard-card-left">
          <p><span class="subtitle">{{ $t("statisticsMeta.publishedOn") }} :</span> {{ publishedDate ? moment(publishedDate).format('DD/MM/YYYY') : "" }}</p>
          <p class="separated-details" v-if="views !== undefined">{{ $t("statisticsMeta.viewsNumber") }} : <span class="highlight">{{ views }}</span></p>
          <p>{{ $t("statisticsMeta.likeNumber") }} : <span class="highlight">{{ likes }}</span></p>
          <p v-if="shares !== undefined" >{{ $t("statisticsMeta.shares") }} : <span class="highlight">{{ shares }}</span></p>
          <p>{{ $t("statisticsMeta.comments") }} : <span class="highlight">{{ comments }}</span></p>
          <p v-if="saves  !== undefined">{{ $t("statisticsMeta.savesNumber") }} : <span class="highlight">{{ saves }}</span></p>
        </div>
        <!-- Encart droit -->
        <div class="card-right" data-test="publicationCard-card-right">
            <p class="subtitle">{{ $t("statisticsMeta.description") }} : </p>
            <p>{{ truncatedDescription }}</p>
        </div>
      </div>
    </div>
</template>

<script>
import moment from 'moment/moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    image: String,
    views: Number,
    likes: Number,
    shares: Number,
    comments: Number,
    saves: Number,
    publishedDate: String,
    reference: String,
    description: String
  },
  computed: {
    ...mapGetters(['isUserDemo', 'getSitimmoUser']),
    moment () {
      return moment
    },
    truncatedDescription () {
      return this.description && this.description.length > 200
        ? this.description.substring(0, 200) + '...'
        : this.description
    }
  },
  methods: {
    getMediaType (url) {
      const reelRegex = /\.(mp4)/i
      const imageRegex = /\.(png|jpg|jpeg)/i
      if (!url) {
        return 'unknown'
      }
      if (imageRegex.test(url)) {
        return 'Image found'
      }
      if (reelRegex.test(url)) {
        return 'Video found'
      }
    },
    getImageUrl (imageName) {
      return require(`@/assets/fakePictures/${this.getSitimmoUser.login}/${imageName}`)
    }
  }
}
</script>

<style scoped>
.card {
  width: 450px;
  height: 400px;
  border: 1px solid #ccc;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.card-header {
  width: 100%;
  height: 200px;
  display: flex;
  background: #FFEFDF;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.card-header img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.card-body {
  max-height: 400px;
  padding: 15px;
  flex-grow: 1;
  display: flex;
  justify-content: space-around;
}

.card-left {
  min-width: 50%;
}

.card-right {
  min-width: 50%;
  margin-left: 10px;
}

.card-left p,
.card-right p {
  min-width: 50%;
  margin: 5px 0;
  color: #000;
}

.card-video {
  width: 100%;
  height: auto;
  max-width: 300px;
  max-height: 180px;
  border: none;
}

.highlight {
  color: #00a4bd;
  font-weight: 700;
}

.subtitle{
  color: #184a56;
  line-height: 1.5;
  font-weight: 700;
}

.bg-app-photo {
  background: #FFEFDF;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-app-photo img {
  width: 200px;
  height: auto;
}

.card-footer{
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 30px;
  background: #FFFFFF;
}
</style>
